import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { AXIS, GRID, TOOLTIP_STYLE } from './ChartCard.js';

interface Row {
  codigo: string;
  value: number;
}

/** Horizontal ranking of sedes by a value (chart #7). */
export function SedeRankingChart({ data, unit }: { data: Row[]; unit?: string }) {
  const sorted = [...data].sort((a, b) => b.value - a.value);
  return (
    <ResponsiveContainer width="100%" height={280}>
      <BarChart data={sorted} layout="vertical" margin={{ top: 8, right: 16, bottom: 8, left: 8 }}>
        <CartesianGrid strokeDasharray="3 3" stroke={GRID} />
        <XAxis type="number" tick={AXIS} unit={unit} />
        <YAxis type="category" dataKey="codigo" tick={AXIS} width={56} />
        <Tooltip contentStyle={TOOLTIP_STYLE} />
        <Bar dataKey="value" name="Valor" fill="#3b82f6" radius={[0, 4, 4, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}
